"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REGISTRATION_SEND_SMS_TYPE = exports.REGISTRATION_REGISTER_TYPE = exports.REGISTRATION_CONFIRM_PHONE_TYPE = void 0;
const REGISTRATION_REGISTER_TYPE = exports.REGISTRATION_REGISTER_TYPE = 'registration/register/status_changed';
const REGISTRATION_SEND_SMS_TYPE = exports.REGISTRATION_SEND_SMS_TYPE = 'registration/sendSms/status_changed';
const REGISTRATION_CONFIRM_PHONE_TYPE = exports.REGISTRATION_CONFIRM_PHONE_TYPE = 'registration/confirmPhone/status_changed';